import windrowRegistrationAPI from "../../services/windrowRegistrationAPI";

const appError = {
  applicationError: {
    hasError: true,
    error:
      [" We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."]
  }
}

export default {
  healthCheck: ({ commit }) => {
    try {
      windrowRegistrationAPI.healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            return;
          } else {
            commit("setErrors", {
              applicationError: {
                hasError: true,
                error: []
              }
            });
          }
        })
        .catch(error => {
          if (error && error.response && error.response.status === 503) {
            commit("setErrors", {
              applicationError: {
                hasError: true,
                error: ["program-not-available"]
              }
            });
          } else {
            commit("setErrors", {
              applicationError: {
                hasError: true,
                error: []
              }
            });
          }
        })
    } catch (error) {
      commit("setErrors", {
        applicationError: {
          hasError: true,
          error: []
        }
      });
    }
  },
  saveApplicantInformation: ({ commit }, applicationDetails) => {
    commit("setApplicantInformation", applicationDetails)
  },
  saveDocumentsInformation: ({ commit }, documentsDetail) => {
    commit("setDocumentsInformation", documentsDetail);
  },
  sendWindrowRegistrationInfo: ({ commit }, windrowRegistrationInfo) => {
    try {
      windrowRegistrationAPI.postWindrowRegistrationInfo(windrowRegistrationInfo)
        .then(response => {
          if (response && response.status === 200 && response.data && response.data.isSuccess) {
            commit("setApplicantInformation", {
              value: response.data.keyId,
              name: "keyId"
            });
            commit("setApplicantInformation", {
              value: response.data.confirmationNumber,
              name: "confirmationNumber"
            });
            commit("setErrors", {
              applicantInfo: {
                hasError: !response.data.isSuccess,
                error: []
              },
              applicationError: {
                hasError: !response.data.isSuccess,
                error: []
              }
            });
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(error => {
          let applicantInfoErrors = [];
          let recaptchaError = [];
          if (error && error.response && error.response.status === 400 && error.response.data && error.response.data.errors) {
            if (error.response.data.errors.RecaptchaToken) {
              recaptchaError.push(error.response.data.errors.RecaptchaToken[0]);
            } else {
              (Object.entries(error.response.data.errors) || []).map(([key, value]) => {
                const errorKeys = key?.split(']').join("")?.split('[');
                if (errorKeys[0].includes("WindrowRequestFamilyMembers")) { }
                else {
                  applicantInfoErrors.push(`${errorKeys[0]} - ${value}`);
                }
              });
            }
            commit("setErrors", {
              applicantInfo: {
                hasError: applicantInfoErrors.length ? true : false,
                error: applicantInfoErrors
              },
              recaptcha: {
                hasError: recaptchaError.length ? true : false,
                error: recaptchaError
              },
              applicationError: {
                hasError: false,
                error: []
              }
            });
          } else if (error && error.code === "ECONNABORTED" && error.response.data && error.response.data.errors) {
            commit("setErrors", {
              timeoutError: {
                hasError: true,
                error: error.response.data.errors.Files || []
              }
            });
          } else {
            commit("setErrors", {
              applicationError: {
                hasError: true,
                error: []
              }
            });
          }
        });
    } catch (error) {
      console.log(error)
    }
  },
  uploadDocuments: ({ commit }, { filesUploadInfo, nextStep }) => {
    try {
      windrowRegistrationAPI.uploadDocuments(filesUploadInfo)
        .then(response => {
          if (response && response.status === 200 && response.data && response.data.isSuccess) {
            commit("setErrors", {
              uploadDocuments: {
                hasError: !response.data.isSuccess,
                error: []
              }
            });
            nextStep();
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(error => {
          if (error && error.response && error.response.status === 400 && error.response.data && error.response.data.errors) {
            let uploadErrors = [];
            if (error.response.data.errors) {
              Object.values(error.response.data.errors).forEach(error => {
                uploadErrors.push(...error);
              })
            }
            if (error.response.data.errors.RecaptchaToken) {
              uploadErrors = [
                ...uploadErrors,
                "Request failed recaptcha validation. Make sure your browser is updated to the latest version. If the problem persists, try using a different browser or contact our Recreation Customer Service Centre at 905-615-4100 or active@mississauga.ca for assistance."
              ];
            }
            commit("setErrors", {
              uploadDocuments: {
                hasError: true,
                error: uploadErrors || []
              }
            });
          } else if (error && error.code === "ECONNABORTED" && error.response.data && error.response.data.errors) {
            commit("setErrors", {
              timeoutError: {
                hasError: true,
                error: error.response.data.errors.Files || []
              }
            });
          } else {
            commit("setErrors", {
              applicationError: {
                hasError: true,
                error: []
              }
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  setErrors: ({ commit }, error) => {
    commit("setErrors", error);
  },
}